"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.delay = delay;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/async.js
// module id = 296
// module chunks = 0